<template>
  <div class="container">
    <div class="row width_full">
      <div class="col_12">
        <div class="common_title">
          <h2>{{ pageTitle }}</h2>
        </div>
        <div class="row">
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('name')}]">
              <label>Title (Korean)</label>
              <input type="text" class="form_global" placeholder="Title Korean" v-model="form.name">
              <template v-if="errors && errors.name">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('name_en')}]">
              <label>Title (English)</label>
              <input type="text" class="form_global" placeholder="Title English" v-model="form.name_en">
              <template v-if="errors && errors.name_en">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name_en" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('image')}]">
              <label>Image</label>
              <input type="file" class="form_global" ref="imageInput" accept="image/png, image/gif, image/jpeg, video/mp4,video/x-m4v,video/*" @input="onFileChange($event)">
              <template v-if="errors && errors.image">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.image" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div class="form-group p_relative" v-if="tempImage && tempType == 'image'">
              <div class="cross_ic p_absolute" v-if="!form.id" @click.prevent="deleteFile">
                <i class="fas fa-times"></i>
              </div>
              <img :src="tempImage" alt=""   width="150">
              <div v-if="form.image && $route.name === 'news_edit'" class="cross_ic" @click="deleteContentFile(form.id)"> <i class='bx bx-x'></i> </div>
            </div>
            <div class="form-group p_relative" v-if="tempImage && tempType == 'video'">
              <div class="cross_ic p_absolute" v-if="!form.id" @click.prevent="deleteFile">
                <i class="fas fa-times"></i>
              </div>
              <video   width="150" :src="tempImage" controls>
                Your browser does not support the video tag.
              </video>
              <div v-if="form.image && $route.name === 'news_edit'" class="cross_ic" @click="deleteContentFile(form.id)"> <i class='bx bx-x'></i> </div>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group']">
              <label>Status</label>
              <select  class="form_global" v-model="form.status">
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col_12">
            <div class="form-group">
              <label>Description</label>
              <text-editor v-model:text="form['description']" :id="'description'" :height="500"></text-editor>
            </div>
          </div>
        </div>
        <div class="d_flex_end">
          <button class="btn btn_danger mr_10" @click="cancelForm()">Cancel</button>
          <button class="btn btn_common" @click="submitForm()">Save <i v-if="loading" class="fas fa-circle-notch fa-spin ml_5"></i></button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import TextEditor from "../../components/shared/TextEditor";
export default {
  name: "Form",
  components: {TextEditor},
  data(){
    return {
      pages: [],
      form:{
        name: '',
        name_en: '',
        image: '',
        description: '',
      },
      tempImage: '',
      tempType: '',
      pageTitle: 'Add New News'
    }
  },
  created() {
    if(this.$route.name === 'news_edit') {
      this.pageTitle = "Edit News"
      this.loadCurrentPage()
    }
  },
  methods:{
    onFileChange(event){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;

      let file = event.target.files[0]
      this.form.image = file

      let imageTypes = ['image/png', 'image/gif', 'image/jpeg']
      let videoTypes = ['video/mp4','video/x-m4v']

      if(imageTypes.includes(file.type)){
        this.tempType = 'image'
      }else if(videoTypes.includes(file.type)){
        this.tempType = 'video'
      }
      this.tempImage = URL.createObjectURL(file);
    },
    deleteFile(){
      this.tempImage = null
      this.tempType = null
      this.form.image = null
      this.$refs.imageInput.value = null
    },

    loadCurrentPage(){
      this.axios.get('/news/'+this.$route.params.id)
          .then((response) => {
            this.form = response.data.data
            this.tempType = this.form.file_type
            this.tempImage = this.form.image
          })
    },
    submitForm(){
      this.errors = null;
      this.loading = true;

      let formData = new FormData()

      Object.keys(this.form).forEach(key => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      })

      if(this.$route.name === 'news_edit') {
        formData.append('_method','PATCH')
        this.axios.post('/news/'+this.$route.params.id, formData)
            .then(() => {
              this.$router.push({name: 'news'})
              this.showSuccessMsg('News Updated!')
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      } else {
        this.axios.post('/news', formData)
            .then(() => {
              this.$router.push({name: 'news'})
              this.showSuccessMsg('News Added!')
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      }
    },
    cancelForm(){
      this.$router.push({name: 'news'})
    },
    deleteContentFile(id){
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.get('/news-file-delete/'+id).then(() => {
            this.$swal.fire(
                'Deleted',
                'File has been deleted!',
                'success'
            )
            this.form.image = ''
            this.tempImage = ''
          });
        }
      });
    },
  }
}
</script>
<style scoped>
.media_wrap{
  position: absolute;
  z-index: 9;
  top: 70px;
  right: 15px;
}
.media_wrap img, .media_wrap video{
  max-height: 150px;
}
</style>